



	// js for filter sort on collection phone
		// Add existing sort parameters to current URL
if( document.body.classList.contains('template-collection') ){

  document.querySelector('.desktop_filter_sort').addEventListener('change', function(e) {
    var value = e.currentTarget.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });
  
}

const classExists = document.getElementsByClassName('thirdlevel--meganav').length > 0;
if (classExists) {
  custom_drag_to_scroll('.thirdlevel--meganav');  // for meganav third level menu
}

const mediaQuery = window.matchMedia('(min-width: 768px)');

if( document.body.classList.contains('template-product') ){

	if (mediaQuery.matches) {
      	if($(".bundle_slider_block").length){	 
			custom_drag_to_scroll('.bundle_slider_block'); // for bundle slide on deskop
    	}
	}	

}

function custom_drag_to_scroll( class_name ) {
 

//  js for slide on mouse drag 
    const target_slider_block = document.querySelector( class_name );
    let isDown = false;
    let startX;
    let scrollLeft;

    target_slider_block.addEventListener('mousedown', (e) => {
      isDown = true;
      target_slider_block.classList.add('active');
      startX = e.pageX - target_slider_block.offsetLeft;
      scrollLeft = target_slider_block.scrollLeft;
    });
    target_slider_block.addEventListener('mouseleave', () => {
      isDown = false;
      target_slider_block.classList.remove('active');
    });
    target_slider_block.addEventListener('mouseup', () => {
      isDown = false;
      target_slider_block.classList.remove('active');
    });
    target_slider_block.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - target_slider_block.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      target_slider_block.scrollLeft = scrollLeft - walk;
      console.log(walk);
    });
//  end js for slide on mouse drag 

}


jQuery( document ).ready(function($) {

if( ($('body').hasClass('template-collection')) ){

  if (window.matchMedia('(max-width: 768px)').matches) {
  		
 	  var title = $('.template-collection .page--section-title');
      var div_height = title.outerHeight();
      var lineheight = parseInt( title.css('line-height') , 10 );
      var num_line = parseInt( div_height / lineheight );
      // console.log( 'title' + title );
      // console.log( 'div_height' + div_height );
      // console.log( 'lineheight' + lineheight );
      //console.log( 'num_line' + num_line );

      if( num_line == 3 ){
          title.css("fontSize", '8vw');
		console.log( 'num_line' + num_line );
      }
      if( num_line == 4 ){
          title.css("fontSize", '6vw');
			console.log( 'num_line' + num_line );
      }
      if( num_line > 4 ){
          title.css("fontSize", '5vw');
			console.log( 'num_line' + num_line );
      }
		

  }	

}

  if ( ($('body').hasClass('template-product')) ) {  


		// FOR on click review start scroll to review section perfactly
    	$(".yotpo.bottomLine").unbind("click").bind("click", function(){
            //alert("this is Overridden click event!");
    		//$('html, body').css( "scroll-padding-top" , "250px");
			$('html, body').css( "scroll-padding-top" , "176px");

        });

      $('input[type="radio"].option_btn').on('click', function(e) {
              $('.select-option-txt-btn').addClass('hidden');
              if( $(this).hasClass('sold') ){
                $('.add-to-bag-btn button .AddToCartText ').html('Sold Out');
                $('.add-to-bag-btn button.addToCart').attr('disabled','disabled');       
                $('.add-to-bag-btn').removeClass('hidden');
              }else{
                  $('.add-to-bag-btn button .AddToCartText ').html('Add to Bag');
                $('.add-to-bag-btn button.addToCart').removeAttr('disabled');
                  $('.add-to-bag-btn').removeClass('hidden');  
              }
              
      }); 

  }
  
  $('.wrap_thumbnail_slider').slick({
  dots: false,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 500,
  slidesToShow: 1,
    infinite: true,
 slidesToScroll: 1,
   fade: true,
  cssEase: 'linear',
     pauseOnHover:false,
     pauseOnFocus: false,
});



  

// }, 10000);
  
//   if($( '#shopify-section-product-template .carousel-main' ).hasClass('single-product_autoplay')){
//   	flkty.options.autoPlay=2000;
//     flkty.playPlayer();
//     $('body').on('click','.product-image-nav-item.carousel-cell',function(){
//     flkty.pausePlayer();
//     });
//   }


	// for mobile Product img
  var get_image_height = $(".noslide").css("height");
      if($(".resp-img-wrapper").hasClass("wrapper_img_prod_thumbnail")){
//       $(".wrapper_img_prod_thumbnail .slick-slider").css("height", get_image_height);
        $(".wrapper_img_prod_thumbnail .product-grid__img").css("height", get_image_height);
        $(".grid__item .wrapper_img_prod_thumbnail").css({"height": get_image_height, "overflow": "hidden"});
      
      }

	// for desktop Product img
	var get_image_height_dsktp = $(".spfc-desktop .noslide").css("height");
// 	console.log(get_image_height_dsktp);
      if($(".spfc-desktop .resp-img-wrapper").hasClass("wrapper_img_prod_thumbnail")){
//       $(".wrapper_img_prod_thumbnail .slick-slider").css("height", get_image_height);
        $(".spfc-desktop .wrapper_img_prod_thumbnail .product-grid__img").css("height", get_image_height_dsktp);
        $(".spfc-desktop .grid__item .wrapper_img_prod_thumbnail").css({"height": get_image_height_dsktp, "overflow": "hidden"});
      
      }

  
    });

jQuery(document).ready(function(){

  if (window.matchMedia('(min-width: 1199px)').matches) {
    
    $('.product_related .grid.product-grid .grid__item.product-grid-item-buy').each(function(index, value){
        if (index >= 5 ){
            $(this).css("display","none");
                    }
    });
    
    if ( ($('body').hasClass('template-collection')) || ($('body').hasClass('template-search')) ) {  
        

	  $('.spfc-desktop .grid__item.product-grid-item-buy').each(function(index, value){
                count = index + 1 ;
                if( count <= 4 ){
                    $(this).addClass('cmp_row_1');
                }else if( count >= 5 && count <= 8 ){
                    $(this).addClass('cmp_row_2');
                }else if( count >= 9 && count <= 12 ){
                    $(this).addClass('cmp_row_3');
                }else if( count >= 13 && count <= 16 ){
                    $(this).addClass('cmp_row_4');
                }else if( count >= 17 && count <= 20 ){
                    $(this).addClass('cmp_row_5');
                }else if( count >= 21 && count <= 24 ){
                    $(this).addClass('cmp_row_6');
                }else if( count >= 25 && count <= 28 ){
                    $(this).addClass('cmp_row_7');
                }else if( count >= 29 && count <= 32 ){
                    $(this).addClass('cmp_row_8');
                }else{
                    //console.log("no_condition_match");
                } 
                
        });



// 		console.log('in above 12000px ');
//         // 8 row 4 column
//        $('.spfc-desktop .grid__item.product-grid-item-buy').each(function(index, value){
//                 count = index + 1 ;
//                 if( count <= 4 ){
//                     $(this).addClass('cmp_row_1');
//                 }else if( count >= 5 && count <= 8 ){
//                     $(this).addClass('cmp_row_2');
//                 }else if( count >= 9 && count <= 12 ){
//                     $(this).addClass('cmp_row_3');
//                 }else if( count >= 13 && count <= 16 ){
//                     $(this).addClass('cmp_row_4');
//                 }else if( count >= 17 && count <= 20 ){
//                     $(this).addClass('cmp_row_5');
//                 }else if( count >= 21 && count <= 24 ){
//                     $(this).addClass('cmp_row_6');
//                 }else if( count >= 25 && count <= 28 ){
//                     $(this).addClass('cmp_row_7');
//                 }else if( count >= 29 && count <= 32 ){
//                     $(this).addClass('cmp_row_8');
//                 }else{
//                     //console.log("no_condition_match");
//                 } 
                
//         });

        set_elemnt_height_ofcollection();

        $(window).scroll(function () {
            set_elemnt_height_ofcollection();
        });
        $(window).load(function () {
            set_elemnt_height_ofcollection();
        });
        $(window).resize(function () {
            set_elemnt_height_ofcollection();
        });

        function get_max_height_of_block( divclass, taragetclass ){
            var height_arr = [];
            i = 0;
           
            $(divclass).each(function(index, value){
                let cur_title_h = $(this).find(taragetclass).outerHeight();
                height_arr[i++] = cur_title_h;
           
            });
            var max_h = height_arr.reduce(function(a, b) {
                    return Math.max(a, b);
            }, 0);
            return max_h;
        }

        function set_elemnt_height_ofcollection(){
          
			var t_product_thumb = ( $('.spfc-desktop .grid__item.product-grid-item-buy').size() / 4 );
			var last_row = Math.ceil( t_product_thumb );
			
            $('.spfc-desktop .grid__item.product-grid-item-buy').each(function(index, value){
                
                let el_classname = 'njnjnj';

                for (let i = 0; i <= last_row ; i++) {
					
					if($(this).hasClass('cmp_row_'+ i )){
                    	el_classname = 'cmp_row_' + i ;
						 break;
                	}		
			
                }

//                 if($(this).hasClass('cmp_row_1')){
//                     el_classname = 'cmp_row_1';
//                 }
//                 if($(this).hasClass('cmp_row_2')){
//                     el_classname = 'cmp_row_2';
//                 }
//                 if($(this).hasClass('cmp_row_3')){
//                     el_classname = 'cmp_row_3';
// 					console.log("in row  3");
//                 }
//                 if($(this).hasClass('cmp_row_4')){
//                     el_classname = 'cmp_row_4';
//                 }
//                 if($(this).hasClass('cmp_row_5')){
//                     el_classname = 'cmp_row_5';
//                 }
//                 if($(this).hasClass('cmp_row_6')){
//                     el_classname = 'cmp_row_6';
//                 }
//                 if($(this).hasClass('cmp_row_7')){
//                     el_classname = 'cmp_row_7';
//                 }
//                 if($(this).hasClass('cmp_row_8')){
//                     el_classname = 'cmp_row_8';
//                 }

                    //for title
                    var get_title_hmax = get_max_height_of_block("." + el_classname ,".product-grid--title");
                  //  console.log("get_title_hmax:" + get_title_hmax);
              //      $(this).find('.product-grid--title').css("min-height", get_title_hmax);
                    
                    //for subtitle
                    var get_subtitle_hmax = get_max_height_of_block("." + el_classname,".product-title-sub");
                   // console.log("get_subtitle_hmax:" + get_subtitle_hmax);
                //    $(this).find('.product-title-sub').css("min-height", get_subtitle_hmax);
              

                          $('.spfc-desktop .grid__item.product-grid-item-buy.'+ el_classname ).each(function(index, value){
                            
                              $(this).find('.pgib-details .product-grid--title').css("min-height", get_title_hmax );
                              $(this).find('.pgib-details .product-title-sub').css("min-height", get_subtitle_hmax );
                              
                          });
                        
                    
            });    
        }

    }

	// for single product page
			
      if ( ($('body').hasClass('template-product')) ) {

          set_elmt_heightof_productpage();

          $(window).scroll(function () {
              set_elmt_heightof_productpage();
          });
          $(window).load(function () {
              set_elmt_heightof_productpage();
          });
          $(window).resize(function () {
              set_elmt_heightof_productpage();
          });

          function set_elmt_heightof_productpage(){
              var spp_max_h_title = 0 ;
              var spp_max_h_subtitle = 0 ;
              $('.grid__item.product-grid-item-buy').each(function(index, value){

                  var spp_cur_title_h = $(this).find('.product-grid--title').outerHeight();
                  var spp_cur_subtitle_h = $(this).find('.product-title-sub').outerHeight();
                  //console.log(spp_cur_title_h);
                  //console.log(spp_cur_subtitle_h);

                  // for title
                  if(spp_cur_title_h > spp_max_h_title ){
                      spp_max_h_title = spp_cur_title_h;
                      //console.log("assingmax title" + spp_max_h_title);
                  }
                  // for subtitle
                  if(spp_cur_subtitle_h > spp_max_h_subtitle ){
                      spp_max_h_subtitle = spp_cur_subtitle_h;
                      //console.log("assingmax subtitle" + spp_max_h_subtitle);
                  }

              });
              $('.grid__item.product-grid-item-buy').each(function(index, value){
                  $(this).find('.product-grid--title').css("min-height", spp_max_h_title);
                  $(this).find('.product-title-sub').css("min-height", spp_max_h_subtitle);
              });
          }

      }

	// end for single product page	 	

    	
          if ( ($('body').hasClass('template-index')) ) {

               function set_elemnt_height_ofhomepage_dsk(){
               		
                 	var m_height_title = 0 ;
                    var m_height_subtitle = 0 ;

                    $('#shopify-section-16098331017157f456 .grid__item.product-grid-item-buy').each(function(index, value){
                        var cur_title_h = $(this).find('.product-grid--title').outerHeight();
                        var cur_subtitle_h = $(this).find('.product-title-sub').outerHeight();

    					     //for title
                            if( cur_title_h > m_height_title ){
                                $(this).find('.product-grid--title').css("min-height", cur_title_h );
                               // console.log('chnages done' + (prev_title_h - cur_title_h));
                                 m_height_title = cur_title_h;
                            }                      
							

                            //for subtitle
                            if( cur_subtitle_h > m_height_subtitle ){
                                $(this).find('.product-title-sub').css("min-height", cur_subtitle_h);
                              	m_height_subtitle = cur_subtitle_h;
                            }                      
                      			
                    });
                 
                 //   console.log("m_height_title" + m_height_title);
                   // console.log("m_height_subtitle" + m_height_subtitle);                       

                    $('#shopify-section-16098331017157f456 .grid__item.product-grid-item-buy').each(function(index, value){
                       $(this).find('.product-grid--title').css("min-height", m_height_title );
                       $(this).find('.product-title-sub').css("min-height", m_height_subtitle);

                    });
                 
                 // for 2nd grid shop all tattos
				
                    var m_height_title = 0 ;
                    var m_height_subtitle = 0 ;
          
                 
                    $('#shopify-section-160984887140e9fb13 .grid__item.product-grid-item-buy').each(function(index, value){
                        var cur_title_h = $(this).find('.product-grid--title').outerHeight();
                        var cur_subtitle_h = $(this).find('.product-title-sub').outerHeight();
          
                           //for title
                          if( cur_title_h > m_height_title ){
                               $(this).find('.product-grid--title').css("min-height", cur_title_h );
                                  // console.log('chnages done' + (prev_title_h - cur_title_h));
                                   m_height_title = cur_title_h;
                          }                      
                                      
        
                         //for subtitle
                         if( cur_subtitle_h > m_height_subtitle ){
                              $(this).find('.product-title-sub').css("min-height", cur_subtitle_h);
                              m_height_subtitle = cur_subtitle_h;
                         }                      
                                            
                    });
                           
                    //console.log("m_height_title" + m_height_title);
                    //console.log("m_height_subtitle" + m_height_subtitle);                       
          
                    $('#shopify-section-160984887140e9fb13 .grid__item.product-grid-item-buy').each(function(index, value){
                         $(this).find('.product-grid--title').css("min-height", m_height_title );
                         $(this).find('.product-title-sub').css("min-height", m_height_subtitle);
          
                   });
                 
                 // end for 2nd grid shop all tattos
                 
					
		  	   }
            
            
              set_elemnt_height_ofhomepage_dsk();

              $(window).scroll(function () {
                  set_elemnt_height_ofhomepage_dsk();
              });
              $(window).load(function () {
                  set_elemnt_height_ofhomepage_dsk();
              });
              $(window).resize(function () {
                  set_elemnt_height_ofhomepage_dsk();
              });
         }
    
  }else{
// 	
    //console.log("in main else ");
    
	if ( ($('body').hasClass('template-collection')) || ($('body').hasClass('template-product')) || ($('body').hasClass('template-search')) ) {

        //console.log("for collection or single product page");
        $('.grid__item.product-grid-item-buy').each(function(index, value){
            //    console.log(index);
                count = index + 1 ;
                if( count % 2 == 0 ){
                    $(this).addClass('right_even');
                }else{
                    $(this).addClass('left_odd');
                  	$(this).css("clear","both");
                } 
        });

        set_elemnt_height_ofcollection();   // for collection page

        $(window).scroll(function () {
            set_elemnt_height_ofcollection();
        });
        $(window).load(function () {
            set_elemnt_height_ofcollection();
        });
        $(window).resize(function () {
            set_elemnt_height_ofcollection();
        });
   
        //  function for home page and also work for single product page
        function set_elemnt_height_ofcollection(){
 				//  console.log("by mob");
            $('.grid__item.product-grid-item-buy').each(function(index, value){
                var cur_title_h = $(this).find('.product-grid--title').outerHeight();
                var cur_subtitle_h = $(this).find('.product-title-sub').outerHeight();
				
        
                if($(this).hasClass('right_even')){
    
                    var prev_title_h = $(this).prev().prev().find('.product-grid--title').outerHeight();
                    var prev_subtitle_h = $(this).prev().prev().find('.product-title-sub').outerHeight();
 					 // console.log(typeof prev_title_h );
 				  	 // console.log(typeof prev_subtitle_h );
                    
                    //for title
                    if( parseFloat(prev_title_h) > parseFloat(cur_title_h) ){
                        $(this).find('.product-grid--title').css("min-height", prev_title_h);
 						 // console.log( $(this).find('.product-grid--title').html() + + prev_title_h + "> " + cur_title_h );
                    }
                    //for subtitle
                    if( parseFloat(prev_subtitle_h) > parseFloat(cur_subtitle_h) ){
                        $(this).find('.product-title-sub').css("min-height", prev_subtitle_h);
 						 // console.log( $(this).prev().prev().find('.product-grid--title').html() );
 						 // console.log( $(this).find('.product-title-sub').html() + prev_subtitle_h + "> " + cur_subtitle_h );
						
                    }
    
                }
    
                if($(this).hasClass('left_odd')){
                    
                    var next_title_h = $(this).next().next().find('.product-grid--title').outerHeight();
                    var next_subtitle_h = $(this).next().next().find('.product-title-sub').outerHeight();
 					// console.log(typeof next_title_h );
  					// console.log(typeof next_subtitle_h );
                    
                    // for title
                    if( parseFloat(next_title_h) > parseFloat(cur_title_h) ){
                        $(this).find('.product-grid--title').css("min-height", next_title_h);
 						// console.log( $(this).find('.product-grid--title').html() + next_title_h + "> " + cur_title_h );
                    }
                    // for subtitle
                    if( parseFloat(next_subtitle_h) > parseFloat(cur_subtitle_h) ){
                        $(this).find('.product-title-sub').css("min-height", next_subtitle_h );
 						// console.log( $(this).find('.product-title-sub').html() + next_subtitle_h + "> " + cur_subtitle_h );
                    }
    
                }
    
            });    
        }
    
        // 
    }

    if ( $('body').hasClass('template-index') ) {
        
        // console.log("for only home page");
        $('#shopify-section-16098331017157f456 .grid__item.product-grid-item-buy').each(function(index, value){
            
                count = index + 1 ;
                if( count % 2 == 0 ){
                    $(this).addClass('right_even');
                }else{
                    $(this).addClass('left_odd');
                } 
        });

        $('#shopify-section-160984887140e9fb13 .grid__item.product-grid-item-buy').each(function(index, value){
            
                count = index + 1 ;
                if( count % 2 == 0 ){
                    $(this).addClass('right_even');
                }else{
                    $(this).addClass('left_odd');
                } 
        });

    
      

        //function for home page

        function set_elemnt_height_ofhomepage(){
            // for oh hey! below prdct
            $('#shopify-section-16098331017157f456 .grid__item.product-grid-item-buy').each(function(index, value){
                var cur_title_h = $(this).find('.product-grid--title').outerHeight();
                var cur_subtitle_h = $(this).find('.product-title-sub').outerHeight();
        
                if($(this).hasClass('right_even')){
        
                    var prev_title_h = $(this).prev().find('.product-grid--title').outerHeight();
                    var prev_subtitle_h = $(this).prev().find('.product-title-sub').outerHeight();
            
                    //for title
                    if( prev_title_h > cur_title_h ){
                        $(this).find('.product-grid--title').css("min-height", prev_title_h);
                       // console.log('chnages done' + (prev_title_h - cur_title_h));
                    }
                    //for subtitle
                    if( prev_subtitle_h > cur_subtitle_h ){
                        $(this).find('.product-title-sub').css("min-height", prev_subtitle_h);
                        // console.log('chnages done' + (prev_subtitle_h - cur_subtitle_h));
                    }
        
                }
        
                if($(this).hasClass('left_odd')){
                    
                    var next_title_h = $(this).next().find('.product-grid--title').outerHeight();
                    var next_subtitle_h = $(this).next().find('.product-title-sub').outerHeight();
        
                    // for title
                    if( next_title_h > cur_title_h ){
                        $(this).find('.product-grid--title').css("min-height", next_title_h);
                        // console.log('chnages done' + (next_title_h - cur_title_h));
                    }
                    // for subtitle
                    if( next_subtitle_h > cur_subtitle_h ){
                        $(this).find('.product-title-sub').css("min-height", next_subtitle_h );
                        // console.log('chnages done' + (next_subtitle_h - cur_subtitle_h));
                    }
        
                }
        
            });

            // for cheer batches below prdct
            $('#shopify-section-160984887140e9fb13 .grid__item.product-grid-item-buy').each(function(index, value){
                var cur_title_h = $(this).find('.product-grid--title').outerHeight();
                var cur_subtitle_h = $(this).find('.product-title-sub').outerHeight();
        
                if($(this).hasClass('right_even')){
        
                    var prev_title_h = $(this).prev().find('.product-grid--title').outerHeight();
                    var prev_subtitle_h = $(this).prev().find('.product-title-sub').outerHeight();
                    
                    //for title
                    if( prev_title_h > cur_title_h ){
                        $(this).find('.product-grid--title').css("min-height", prev_title_h);
                        // console.log('chnages done' + (prev_title_h - cur_title_h));
                    }
                    //for subtitle
                    if( prev_subtitle_h > cur_subtitle_h ){
                        $(this).find('.product-title-sub').css("min-height", prev_subtitle_h);
                        // console.log('chnages done' + (prev_subtitle_h - cur_subtitle_h));
                    }
        
                }
        
                if($(this).hasClass('left_odd')){
                    
                    var next_title_h = $(this).next().find('.product-grid--title').outerHeight();
                    var next_subtitle_h = $(this).next().find('.product-title-sub').outerHeight();
        
                    // for title
                    if( next_title_h > cur_title_h ){
                        $(this).find('.product-grid--title').css("min-height", next_title_h);
                        // console.log('chnages done' + (next_title_h - cur_title_h));
                    }
                    // for subtitle
                    if( next_subtitle_h > cur_subtitle_h ){
                        $(this).find('.product-title-sub').css("min-height", next_subtitle_h );
                        // console.log('chnages done' + (next_subtitle_h - cur_subtitle_h));
                    }
        
                }
        
            });

            // end for cheer batches below product

        }

    }
// 
  }


});

  $(window).on('resize', function(){

// 	$('.wrap_thumbnail_slider').slick({
//       dots: false,
//       arrows: false,
//       infinite: false,
//       autoplay: true,
//       autoplaySpeed: 500,
//       slidesToShow: 1,
//         infinite: true,
//      slidesToScroll: 1,
//        fade: true,
//       cssEase: 'linear',
//          pauseOnHover:false,
//          pauseOnFocus: false,
// 	});

    
	 var get_image_height = $(".noslide").css("height");
    if($(".resp-img-wrapper").hasClass("wrapper_img_prod_thumbnail")){
  		$(".wrapper_img_prod_thumbnail .slick-slider").css("height", get_image_height);
       $(".grid__item .wrapper_img_prod_thumbnail").css({"height": get_image_height, "overflow": "hidden"});
  
  	}

	// for desktop Product img
	var get_image_height_dsktp = $(".spfc-desktop .noslide").css("height");
      if($(".spfc-desktop .resp-img-wrapper").hasClass("wrapper_img_prod_thumbnail")){
//       $(".wrapper_img_prod_thumbnail .slick-slider").css("height", get_image_height);
        $(".spfc-desktop .wrapper_img_prod_thumbnail .product-grid__img").css("height", get_image_height_dsktp);
		$(".spfc-desktop .wrapper_img_prod_thumbnail .wrap_thumbnail_slider").css("height", get_image_height_dsktp);
        $(".spfc-desktop .grid__item .wrapper_img_prod_thumbnail").css({"height": get_image_height_dsktp, "overflow": "hidden"});
      
      }

});
		



// function checkScroll(){$(window).scrollTop()>=50&&!$("html").hasClass("stop-scroll")?$("body").addClass("scrolled"):$("body").removeClass("scrolled")}jQuery(function(){jQuery(".swatch :radio").change(function(){var e=jQuery(this).closest(".swatch").attr("data-option-index"),t=jQuery(this).val();jQuery(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")})}),$(document).ready(function(){checkScroll(),$(window).scroll(checkScroll)}),$(".swatch-button").click(function(){$(this).next().click(),$(this).parents(".shopify-product-form").find(".cta-content").removeClass("hidden"),$(this).parents(".shopify-product-form").find(".select-variant").addClass("hidden"),$(this).parent().siblings().removeClass("selected"),$(this).parent().addClass("selected");var e=$(this).parents(".product-page--form").siblings(".grid__image").children(".variantImgWrapper");e.addClass("fadeout");var t=$(this).attr("data-variant-name"),s=$("#varImgWrp_"+t).html(),n=Handlebars.compile(s);setTimeout(function(){e.empty(),e.html(n),e.removeClass("fadeout")},300)}),$(".select-variant").click(function(){$(this).parents(".shopify-product-form").children(".swatch").removeClass("hidden")}),$(window).load(function(){var e=Cookies.get("status");null==e?Cookies.set("status","visited"):"visited"==e&&setTimeout(function(){$(".newsletter-popup").removeClass("hidden")},3e3)}),$(".close-popup").click(function(){$(".newsletter-popup").addClass("hidden"),Cookies.set("status","closed",{expires:7})}),$(".wave-icon").on("mouseenter",function(){$(this).addClass("animate")}),$(".wave-icon").on("animationend",function(){$(this).removeClass("animate")}),$(".search__item input").focus(function(){$(this).parents(".search__item").addClass("focused")}),$(".search__item input").focusout(function(){""==$(this).val()&&$(this).parents(".search__item").removeClass("focused")}),PageInits={collection:function(e){var t=0,s=$(e),n=("eH"+Math.random()).replace(".","");s.each(function(){var e=$(this).offset().top;e>t&&($("."+n).removeClass(n),t=e),$(this).addClass(n),$(this).css("min-height","auto");var s=Math.max.apply(null,$("."+n).map(function(){return $(this).outerHeight()}).get());$("."+n).css("min-height",s)}).removeClass(n)},product:function(){$(".product-single");var e=$(".carousel-container");$(".ppproduct-description-wrapper").css("height",e.outerHeight())},header:function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())}},$(window).scroll(function(){PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product(),console.log($(window).scrollTop()),console.log("&"),console.log($(".site-header").outerHeight()),0==$(window).scrollTop()&&setInterval(function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())},100)}),$(window).load(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),$(document).ready(function(){PageInits.header()}),$(window).resize(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),navigator.userAgent.includes("Android")?$("html").addClass("android"):navigator.userAgent.includes("Mac")?$("html").addClass("mac"):$("html").addClass("windows"),$(".login").on("click",function(){$(".account-expanded.p2").toggleClass("account-expanded--active")}),$(".main-content").on("click",function(){$(".account-expanded.p2").removeClass("account-expanded--active")}),$(document).ready(function(){$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").on("click",function(e){e.preventDefault(),e.stopPropagation(),$(this).hasClass("active")?($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide()):($(".site-nav__link").removeClass("active"),$(".site-nav__link").next().removeClass("active"),$(".site-nav__dropdown").hide(),$(this).addClass("active"),$(this).next().addClass("active"),$(this).next().show())})}),$(window).click(function(){$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").hasClass("active")&&($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide())});

//  below is  modify minify code above minify js

// function checkScroll(){$(window).scrollTop()>=50&&!$("html").hasClass("stop-scroll")?$("body").addClass("scrolled"):$("body").removeClass("scrolled")}jQuery(function(){jQuery(".swatch :radio").change(function(){var e=jQuery(this).closest(".swatch").attr("data-option-index"),t=jQuery(this).val();jQuery(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")})}),$(document).ready(function(){$(window).width()>767&&(checkScroll(),$(window).scroll(checkScroll))}),$(".swatch-button").click(function(){$(this).next().click(),$(this).parents(".shopify-product-form").find(".cta-content").removeClass("hidden"),$(this).parents(".shopify-product-form").find(".select-variant").addClass("hidden"),$(this).parent().siblings().removeClass("selected"),$(this).parent().addClass("selected");var e=$(this).parents(".product-page--form").siblings(".grid__image").children(".variantImgWrapper");e.addClass("fadeout");var t=$(this).attr("data-variant-name"),s=$("#varImgWrp_"+t).html(),i=Handlebars.compile(s);setTimeout(function(){e.empty(),e.html(i),e.removeClass("fadeout")},300)}),$(".select-variant").click(function(){$(this).parents(".shopify-product-form").children(".swatch").removeClass("hidden")}),$(window).load(function(){var e=Cookies.get("status");null==e?Cookies.set("status","visited"):"visited"==e&&setTimeout(function(){$(".newsletter-popup").removeClass("hidden")},3e3)}),$(".close-popup").click(function(){$(".newsletter-popup").addClass("hidden"),Cookies.set("status","closed",{expires:7})}),$(".wave-icon").on("mouseenter",function(){$(this).addClass("animate")}),$(".wave-icon").on("animationend",function(){$(this).removeClass("animate")}),$(".search__item input").focus(function(){$(this).parents(".search__item").addClass("focused")}),$(".search__item input").focusout(function(){""==$(this).val()&&$(this).parents(".search__item").removeClass("focused")}),PageInits={collection:function(e){var t=0,s=$(e),i=("eH"+Math.random()).replace(".","");s.each(function(){var e=$(this).offset().top;e>t&&($("."+i).removeClass(i),t=e),$(this).addClass(i),$(this).css("min-height","auto");var s=Math.max.apply(null,$("."+i).map(function(){return $(this).outerHeight()}).get());$("."+i).css("min-height",s)}).removeClass(i)},product:function(){$(".product-single");var e=$(".carousel-container");$(".ppproduct-description-wrapper").css("height",e.outerHeight())},header:function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())}},$(window).scroll(function(){$(window).width()>767&&(PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product(),0==$(window).scrollTop()&&setInterval(function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())},100))}),$(window).load(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),$(document).ready(function(){PageInits.header()}),$(window).resize(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),navigator.userAgent.includes("Android")?$("html").addClass("android"):navigator.userAgent.includes("Mac")?$("html").addClass("mac"):$("html").addClass("windows"),$(".login").on("click",function(){$(".account-expanded.p2").toggleClass("account-expanded--active")}),$(".main-content").on("click",function(){$(".account-expanded.p2").removeClass("account-expanded--active")}),$(document).ready(function(){$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").on("click",function(e){e.preventDefault(),e.stopPropagation(),$(this).hasClass("active")?($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide()):($(".site-nav__link").removeClass("active"),$(".site-nav__link").next().removeClass("active"),$(".site-nav__dropdown").hide(),$(this).addClass("active"),$(this).next().addClass("active"),$(this).next().show())})}),$(window).click(function(){$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").hasClass("active")&&($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide())});

//  below is modify js of  above minify js .

 // last 

// function checkScroll(){$(window).scrollTop()>=50&&!$("html").hasClass("stop-scroll")?$("body").addClass("scrolled"):$("body").removeClass("scrolled")}jQuery(function(){jQuery(".swatch :radio").change(function(){var e=jQuery(this).closest(".swatch").attr("data-option-index"),t=jQuery(this).val();jQuery(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")})}),$(document).ready(function(){$(window).width()>767&&(checkScroll(),$(window).scroll(checkScroll))}),$(".swatch-button").click(function(){$(this).next().click(),$(this).parents(".shopify-product-form").find(".cta-content").removeClass("hidden"),$(this).parents(".shopify-product-form").find(".select-variant").addClass("hidden"),$(this).parent().siblings().removeClass("selected"),$(this).parent().addClass("selected");var e=$(this).parents(".product-page--form").siblings(".grid__image").children(".variantImgWrapper");e.addClass("fadeout");var t=$(this).attr("data-variant-name"),s=$("#varImgWrp_"+t).html(),a=Handlebars.compile(s);setTimeout(function(){e.empty(),e.html(a),e.removeClass("fadeout")},300)}),$(".select-variant").click(function(){$(this).parents(".shopify-product-form").children(".swatch").removeClass("hidden")}),$(window).load(function(){var e=Cookies.get("status");null==e?Cookies.set("status","visited"):"visited"==e&&setTimeout(function(){$(".newsletter-popup").removeClass("hidden")},3e3)}),$(".close-popup").click(function(){$(".newsletter-popup").addClass("hidden"),Cookies.set("status","closed",{expires:7})}),$(".wave-icon").on("mouseenter",function(){$(this).addClass("animate")}),$(".wave-icon").on("animationend",function(){$(this).removeClass("animate")}),$(".search__item input").focus(function(){$(this).parents(".search__item").addClass("focused")}),$(".search__item input").focusout(function(){""==$(this).val()&&$(this).parents(".search__item").removeClass("focused")}),PageInits={collection:function(e){var t=0,s=$(e),a=("eH"+Math.random()).replace(".","");s.each(function(){var e=$(this).offset().top;e>t&&($("."+a).removeClass(a),t=e),$(this).addClass(a),$(this).css("min-height","auto");var s=Math.max.apply(null,$("."+a).map(function(){return $(this).outerHeight()}).get());$("."+a).css("min-height",s)}).removeClass(a)},product:function(){$(".product-single");var e=$(".carousel-container");$(".ppproduct-description-wrapper").css("height",e.outerHeight())},header:function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())}},$(window).scroll(function(){$(window).width()>1199&&PageInits.product(),0==$(window).scrollTop()&&setInterval(function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())},100)}),$(window).load(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),$(document).ready(function(){PageInits.header()}),$(window).resize(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),navigator.userAgent.includes("Android")?$("html").addClass("android"):navigator.userAgent.includes("Mac")?$("html").addClass("mac"):$("html").addClass("windows"),$(".login").on("click",function(){$(".account-expanded.p2").toggleClass("account-expanded--active")}),$(".main-content").on("click",function(){$(".account-expanded.p2").removeClass("account-expanded--active")}),$(document).ready(function(){$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").on("click",function(e){e.preventDefault(),e.stopPropagation(),$(this).hasClass("active")?($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide()):($(".site-nav__link").removeClass("active"),$(".site-nav__link").next().removeClass("active"),$(".site-nav__dropdown").hide(),$(this).addClass("active"),$(this).next().addClass("active"),$(this).next().show())})}),$(window).click(function(){$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").hasClass("active")&&($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide())});


// 25-03-2022 (updated)
// function checkScroll(){$(window).scrollTop()>=50&&!$("html").hasClass("stop-scroll")?$("body").addClass("scrolled"):$("body").removeClass("scrolled")}jQuery(function(){jQuery(".swatch :radio").change(function(){var e=jQuery(this).closest(".swatch").attr("data-option-index"),t=jQuery(this).val();jQuery(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")})}),$(document).ready(function(){$(window).width()>767&&(checkScroll(),$(window).scroll(checkScroll))}),$(".swatch-button").click(function(){$(this).next().click(),$(this).parents(".shopify-product-form").find(".cta-content").removeClass("hidden"),$(this).parents(".shopify-product-form").find(".select-variant").addClass("hidden"),$(this).parent().siblings().removeClass("selected"),$(this).parent().addClass("selected");var e=$(this).parents(".product-page--form").siblings(".grid__image").children(".variantImgWrapper");e.addClass("fadeout");var t=$(this).attr("data-variant-name"),s=$("#varImgWrp_"+t).html(),a=Handlebars.compile(s);setTimeout(function(){e.empty(),e.html(a),e.removeClass("fadeout")},300)}),$(".select-variant").click(function(){$(this).parents(".shopify-product-form").children(".swatch").removeClass("hidden")}),$(window).load(function(){var e=Cookies.get("status");null==e?Cookies.set("status","visited"):"visited"==e&&setTimeout(function(){$(".newsletter-popup").removeClass("hidden")},3e3)}),$(".close-popup").click(function(){$(".newsletter-popup").addClass("hidden"),Cookies.set("status","closed",{expires:7})}),$(".wave-icon").on("mouseenter",function(){$(this).addClass("animate")}),$(".wave-icon").on("animationend",function(){$(this).removeClass("animate")}),$(".search__item input").focus(function(){$(this).parents(".search__item").addClass("focused")}),$(".search__item input").focusout(function(){""==$(this).val()&&$(this).parents(".search__item").removeClass("focused")}),PageInits={collection:function(e){var t=0,s=$(e),a=("eH"+Math.random()).replace(".","");s.each(function(){var e=$(this).offset().top;e>t&&($("."+a).removeClass(a),t=e),$(this).addClass(a),$(this).css("min-height","auto");var s=Math.max.apply(null,$("."+a).map(function(){return $(this).outerHeight()}).get());$("."+a).css("min-height",s)}).removeClass(a)},product:function(){$(".product-single");var e=$(".carousel-container");$(".ppproduct-description-wrapper").css("height",e.outerHeight())},header:function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())}},$(window).scroll(function(){$(window).width()>1199&&PageInits.product(),0==$(window).scrollTop()&&setInterval(function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())},100)}),$(window).load(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),$(document).ready(function(){PageInits.header()}),$(window).resize(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),navigator.userAgent.includes("Android")?$("html").addClass("android"):navigator.userAgent.includes("Mac")?$("html").addClass("mac"):$("html").addClass("windows"),$(".login").on("click",function(){$(".account-expanded.p2").toggleClass("account-expanded--active")}),$(".main-content").on("click",function(){$(".account-expanded.p2").removeClass("account-expanded--active")}),$(document).ready(function(){$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").not("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__dropdown .thirdlevel--meganav li .site-nav__link").not("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__dropdown .thirdlevel--meganav").on("click",function(e){e.preventDefault(),e.stopPropagation(),$(this).hasClass("active")?($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide()):($(".site-nav__link").removeClass("active"),$(".site-nav__link").next().removeClass("active"),$(".site-nav__dropdown").hide(),$(this).addClass("active"),$(this).next().addClass("active"),$(this).next().show())})}),$("body").click(function(e){$(e.target).is(".thirdlevel--meganav")||$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").hasClass("active")&&($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide())});

//18-04-2022
// function checkScroll(){$(window).scrollTop()>=39&&!$("html").hasClass("stop-scroll")?$("body").addClass("scrolled"):$("body").removeClass("scrolled")}jQuery(function(){jQuery(".swatch :radio").change(function(){var e=jQuery(this).closest(".swatch").attr("data-option-index"),s=jQuery(this).val();jQuery(this).closest("form").find(".single-option-selector").eq(e).val(s).trigger("change")})}),$(document).ready(function(){$(window).width()>300&&(checkScroll(),$(window).scroll(checkScroll))}),$(".swatch-button").click(function(){$(this).next().click(),$(this).parents(".shopify-product-form").find(".cta-content").removeClass("hidden"),$(this).parents(".shopify-product-form").find(".select-variant").addClass("hidden"),$(this).parent().siblings().removeClass("selected"),$(this).parent().addClass("selected");var e=$(this).parents(".product-page--form").siblings(".grid__image").children(".variantImgWrapper");e.addClass("fadeout");var s=$(this).attr("data-variant-name"),t=$("#varImgWrp_"+s).html(),a=Handlebars.compile(t);setTimeout(function(){e.empty(),e.html(a),e.removeClass("fadeout")},300)}),$(".select-variant").click(function(){$(this).parents(".shopify-product-form").children(".swatch").removeClass("hidden")}),$(window).load(function(){var e=Cookies.get("status");null==e?Cookies.set("status","visited"):"visited"==e&&setTimeout(function(){$(".newsletter-popup").removeClass("hidden")},3e3)}),$(".close-popup").click(function(){$(".newsletter-popup").addClass("hidden"),Cookies.set("status","closed",{expires:7})}),$(".wave-icon").on("mouseenter",function(){$(this).addClass("animate")}),$(".wave-icon").on("animationend",function(){$(this).removeClass("animate")}),$(".search__item input").focus(function(){$(this).parents(".search__item").addClass("focused")}),$(".search__item input").focusout(function(){""==$(this).val()&&$(this).parents(".search__item").removeClass("focused")}),PageInits={collection:function(e){var s=0,t=$(e),a=("eH"+Math.random()).replace(".","");t.each(function(){var e=$(this).offset().top;e>s&&($("."+a).removeClass(a),s=e),$(this).addClass(a),$(this).css("min-height","auto");var t=Math.max.apply(null,$("."+a).map(function(){return $(this).outerHeight()}).get());$("."+a).css("min-height",t)}).removeClass(a)},product:function(){$(".product-single");var e=$(".carousel-container");$(".ppproduct-description-wrapper").css("height",e.outerHeight())},header:function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())}},$(window).scroll(function(){$(window).width()>1199&&PageInits.product(),0==$(window).scrollTop()&&setInterval(function(){$("#shopify-section-header").css("min-height",$(".site-header").outerHeight())},100)}),$(window).load(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),$(document).ready(function(){PageInits.header()}),$(window).resize(function(){PageInits.header(),PageInits.collection(".product-grid--title"),PageInits.collection(".product-title-sub"),$(window).width()>1199&&PageInits.product()}),navigator.userAgent.includes("Android")?$("html").addClass("android"):navigator.userAgent.includes("Mac")?$("html").addClass("mac"):$("html").addClass("windows"),$(".login").on("click",function(){$(".account-expanded.p2").toggleClass("account-expanded--active")}),$(".main-content").on("click",function(){$(".account-expanded.p2").removeClass("account-expanded--active")}),$(document).ready(function(){$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").not("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__dropdown .thirdlevel--meganav li .site-nav__link").not("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__dropdown .thirdlevel--meganav").on("click",function(e){e.preventDefault(),e.stopPropagation(),$(this).hasClass("active")?($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide()):($(".site-nav__link").removeClass("active"),$(".site-nav__link").next().removeClass("active"),$(".site-nav__dropdown").hide(),$(this).addClass("active"),$(this).next().addClass("active"),$(this).next().show())})}),$("body").click(function(e){$(e.target).is(".thirdlevel--meganav")||$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").hasClass("active")&&($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),$("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide())});

   //  for unminify code check backup file

function checkScroll() {
    $(window).scrollTop() >= 39 && !$("html").hasClass("stop-scroll") ? $("body").addClass("scrolled") : $("body").removeClass("scrolled");
}

function check_all_selected( clk_elem = '' ){
    
    var all_selector =  $('#AddToCartForm--product-template .shopify-product-form').children('.variant_selector');
  
    var show_Atc = false;
    for (let index = 0; index < all_selector.length; index++) {
        const element = all_selector[index];        
        if( element.classList.contains('variant_selected') == true){
            show_Atc = true;
        }else{
            show_Atc = false;
            break;
        }
    }

    if($('[data-product-form]').hasClass('xo_custom_product')){
        var personalization_str = $('#AddToCartForm--product-template .shopify-block #minimate-dynamic-fields .textbox-container input').val();        
        if( personalization_str == '' || personalization_str == ' ' ){
            show_Atc = false;
        }
    }

    if( show_Atc ){
        $("#AddToCartForm--product-template .shopify-product-form").find(".cta-content.add-to-bag-btn").removeClass("hidden");
        $("#AddToCartForm--product-template .shopify-product-form").find(".select-variant").addClass("hidden");
    }else{
        $("#AddToCartForm--product-template .shopify-product-form").find(".cta-content.add-to-bag-btn").addClass("hidden");
        $("#AddToCartForm--product-template .shopify-product-form").find(".select-variant").removeClass("hidden");
    }
    
}

jQuery(function () {
    jQuery(".swatch :radio").change(function () {
        var e = jQuery(this).closest(".swatch").attr("data-option-index"),
            s = jQuery(this).val();
        jQuery(this).closest("form").find(".single-option-selector").eq(e).val(s).trigger("change");
        jQuery(this).parents('.variant_selector').addClass('variant_selected');
        check_all_selected(jQuery(this));
    });

    jQuery(".number_of_letter").change(function () {     
        var e = jQuery(this).closest(".swatch").attr("data-option-index"),
            s = jQuery(this).val();
            if( jQuery(this).val() == ''){
                jQuery(this).parents('.variant_selector').removeClass('variant_selected'); 
            }else{
                jQuery(this).parents('.variant_selector').addClass('variant_selected'); 
            }
        jQuery(this).closest("form").find(".single-option-selector").eq(e).val(s).trigger("change");
        check_all_selected(jQuery(this));
    });

    // for personalization Text custom product
    if(jQuery('[data-product-form]').hasClass('xo_custom_product')){
        var personalization_input = jQuery('#AddToCartForm--product-template .shopify-block #minimate-dynamic-fields .textbox-container input');        
        jQuery(document).on("keyup change", personalization_input, function(event) {
            check_all_selected();
        });       
    }

}),
    $(document).ready(function () {
        $(window).width() > 300 && (checkScroll(), $(window).scroll(checkScroll));
    }),
    $(".swatch-button").click(function () {
        $(this).next().click(),
            $(this).parents('.variant_selector').addClass('variant_selected');            
            $(this).parent().siblings().removeClass("selected"),
            $(this).parent().addClass("selected");
        var e = $(this).parents(".product-page--form").siblings(".grid__image").children(".variantImgWrapper");
        e.addClass("fadeout");
        var s = $(this).attr("data-variant-name"),
            t = $("#varImgWrp_" + s).html(),
            a = Handlebars.compile(t);
        setTimeout(function () {
            e.empty(), e.html(a), e.removeClass("fadeout");
        }, 300);
    }),
    $(".select-variant").click(function () {
        // $(this).parents(".shopify-product-form").children(".swatch").removeClass("hidden");
    }),
    $(window).load(function () {
        var e = Cookies.get("status");
        null == e
            ? Cookies.set("status", "visited")
            : "visited" == e &&
              setTimeout(function () {
                  $(".newsletter-popup").removeClass("hidden");
              }, 3e3);
    }),
    $(".close-popup").click(function () {
        $(".newsletter-popup").addClass("hidden"), Cookies.set("status", "closed", { expires: 7 });
    }),
    $(".wave-icon").on("mouseenter", function () {
        $(this).addClass("animate");
    }),
    $(".wave-icon").on("animationend", function () {
        $(this).removeClass("animate");
    }),
    $(".search__item input").focus(function () {
        $(this).parents(".search__item").addClass("focused");
    }),
    $(".search__item input").focusout(function () {
        "" == $(this).val() && $(this).parents(".search__item").removeClass("focused");
    }),
    (PageInits = {
        collection: function (e) {
            var s = 0,
                t = $(e),
                a = ("eH" + Math.random()).replace(".", "");
            t.each(function () {
                var e = $(this).offset().top;
                e > s && ($("." + a).removeClass(a), (s = e)), $(this).addClass(a), $(this).css("min-height", "auto");
                var t = Math.max.apply(
                    null,
                    $("." + a)
                        .map(function () {
                            return $(this).outerHeight();
                        })
                        .get()
                );
                $("." + a).css("min-height", t);
            }).removeClass(a);
        },
        product: function () {
            $(".product-single");
            var e = $(".carousel-container");
            $(".ppproduct-description-wrapper").css("height", e.outerHeight());
        },
        header: function () {
            $("#shopify-section-header").css("min-height", $(".site-header").outerHeight());
        },
    }),
    $(window).scroll(function () {
        $(window).width() > 1199 && PageInits.product(),
            0 == $(window).scrollTop() &&
                setInterval(function () {
                    $("#shopify-section-header").css("min-height", $(".site-header").outerHeight());
                }, 100);
    }),
    $(window).load(function () {
        PageInits.header(), PageInits.collection(".product-grid--title"), PageInits.collection(".product-title-sub"), $(window).width() > 1199 && PageInits.product();
    }),
    $(document).ready(function () {
        PageInits.header();
    }),
    $(window).resize(function () {
        PageInits.header(), PageInits.collection(".product-grid--title"), PageInits.collection(".product-title-sub"), $(window).width() > 1199 && PageInits.product();
    }),
    navigator.userAgent.includes("Android") ? $("html").addClass("android") : navigator.userAgent.includes("Mac") ? $("html").addClass("mac") : $("html").addClass("windows"),
    $(".login").on("click", function () {
        var $menu = $(this).siblings(".account-expanded");
        $(".account-expanded").not($menu).removeClass("account-expanded--active");
        // Desktop focus/hover already opens this menu; clicking must not close it.
        if ($(this).closest(".site-header__mobile-icon--user").length) {
            $menu.toggleClass("account-expanded--active");
        } else {
            $menu.addClass("account-expanded--active");
        }
    }),
    $(".main-content").on("click", function () {
        $(".account-expanded.p2").removeClass("account-expanded--active");
    }),
    $(document).ready(function () {
        $("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link")
            .not("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__dropdown .thirdlevel--meganav li .site-nav__link")
            .not("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__dropdown .thirdlevel--meganav")
            .on("click", function (e) {
                e.preventDefault(),
                    e.stopPropagation(),
                    $(this).hasClass("active")
                        ? ($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),
                          $("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),
                          $("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide())
                        : ($(".site-nav__link").removeClass("active"),
                          $(".site-nav__link").next().removeClass("active"),
                          $(".site-nav__dropdown").hide(),
                          $(this).addClass("active"),
                          $(this).next().addClass("active"),
                          $(this).next().show());
            });
    }),
    $("body").click(function (e) {
        $(e.target).is(".thirdlevel--meganav") ||
            ($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").hasClass("active") &&
                ($("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").removeClass("active"),
                $("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().removeClass("active"),
                $("#AccessibleNav .site-nav--has-dropdown.site-nav--has-dropdown--meganav .site-nav__link").next().hide()));
    });

document.addEventListener("DOMContentLoaded", () => {
  if (document.body.classList.contains('template-product')) {
    var dataVariantJSON = JSON.parse(document.querySelector("#ProductJson-product-template").innerText);
    var variantsdata = dataVariantJSON.variants;
    var variantSelector = document.querySelector("select[id='ProductSelect']");
    var variant_elem = document.querySelectorAll('.option_btn');
    variant_elem.forEach(function(target){
        target.addEventListener("change", function() {
            var selectedVariantId = variantSelector.value;
            var selectedVariant;
            variantsdata.forEach(function(variant) {
                if( variant.id == selectedVariantId ){
                    selectedVariant = variant;
                }
            }); 

            document.querySelector('.ProductPrice.t--meta').innerText = Shopify.formatMoney(selectedVariant.price);
            document.querySelector('.ProductPrice.t--meta').setAttribute('content', Shopify.formatMoney(selectedVariant.price));
        });        
    });
  }
});